import React from 'react'
import './WebDevelopmentSerivce.css'
import HeroWds from './HeroWds/HeroWds'
import Transform from './Transform/Transform'
import Testimonials from './Testimonials/Testimonials'
import Core from './Core/Core'
import Top from './Top/Top'
import Services from './services/Services';
import Why from './Why/Why'
function WebDevelopmentSerivce() {
    return (
        <div id='wds'>
            <HeroWds/>
            <Transform/>
            <Why/>
            <Core/>
            <Top/>
            <Testimonials/> 
             <Services/>
        </div>
    )
}

export default WebDevelopmentSerivce